declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { HCPService } from '../../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../../models/profileinfo/profileinfo.model';
import { ActorImageController, PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, SavePatientInfoRequest, OverseasController, GenericProcPostRequest, GenericParams, FTV, S_Methods, UpdateOverseas, UpdateBillingCategory, CaseRegistrationByActorCodeController, CaseRegistrationByActorCodeRequest, UpdateWeddingDate } from '../../../../../models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../../../src/app/ncs/services/actor.service';
import { NgbEditProfileModal } from './modal/editprofile.modal';
import { PrintService } from '../../../../../../../../src/app/ncs/services/print.service';
import { NgbPartnerDetails } from './modal/partnerdetails.modal';
import { NgbCameraUploadModal } from './modal/cameraupload.modal';
import { PrintIDLService } from '../../../../../../../../src/app/ncs/services/printIDL.service';
import { NgbAddPartnerModal } from './modal/addpartner.modal';


@Component({
  selector: 'personaldetailview',
  templateUrl: './personaldetailview.component.html',
  styleUrls: ['./personaldetailview.component.scss']
})

export class PersonalDetailViewComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  public isRequesting: boolean = false;
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

  // Collapsible section states
  public isGeneralCollapsed: boolean = false;
  public isEducationCollapsed: boolean = false;
  public isReferralCollapsed: boolean = false;
  public isAddressCollapsed: boolean = false;
  public isContactCollapsed: boolean = false;

  toggleGeneral() { this.isGeneralCollapsed = !this.isGeneralCollapsed; }
  toggleEducation() { this.isEducationCollapsed = !this.isEducationCollapsed; }
  toggleReferral() { this.isReferralCollapsed = !this.isReferralCollapsed; }
  toggleAddress() { this.isAddressCollapsed = !this.isAddressCollapsed; }
  toggleContact() { this.isContactCollapsed = !this.isContactCollapsed; }




  ValueChangeActorImageController: ActorImageController;

  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();

  DOB: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalDetailInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  SelectedPatient: PatientInfoByFormattedCodeController;
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result || (this.ApiResData as any).result || [];
          if (this.CurrentPatientInfoByFormattedCodeController.length > 0) {
            this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];
          }
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    public printService: PrintService, public printServiceIDL: PrintIDLService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }
  CurrentUpdateOverseas: UpdateOverseas;
  CurrentUpdateBillingCategory: UpdateBillingCategory;
  CurrentUpdateWeddingDate: UpdateWeddingDate;
  ngOnInit() {
    this.LoadPatients();
    this.LoadOverseas();
    this.LoadCouple();
    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: 1900, month: 1, day: 1 };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.ActorCode.toString();
    this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSavePatientInfoRequest = new SavePatientInfoRequest();
    //this.CurrentActorEditGuardianInfoRequest.GuardianActorCode = this.ActorCode;
    this.CurrentSavePatientInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentUpdateOverseas = new UpdateOverseas();
    this.CurrentUpdateOverseas.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentUpdateBillingCategory = new UpdateBillingCategory();
    this.CurrentUpdateBillingCategory.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentUpdateWeddingDate = new UpdateWeddingDate();
    this.CurrentUpdateWeddingDate.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorImageController = new ActorImageController();
    if (this.CanShow === 1) {
      this.GetActorPersonalDetailInfoController();
    }

  }

  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorPersonalDetailInfoController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }
  onSubmit() {

    this.StartRefreshing();

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.customdatetimeservice.converToLocalTime(this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //}
    // console.log('this.DOB--->' + this.DOB);
    if (this.DOB != null) {



      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));;

      // console.log('this.DateOfBirth--->' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth );
    }
    this.hcpservice.SaveActorPersonalDetailInfo(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorPersonalDetailInfoController();

            // alertFunctions.AlertParam('Saved Successfully.....!');

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentCaseRegistrationByActorCodeController: CaseRegistrationByActorCodeController[];
  PatientDetailsData: CaseRegistrationByActorCodeController;
  CurrentCaseRegistrationByActorCodeRequest: CaseRegistrationByActorCodeRequest;

  LoadCouple() {
    //alert("ScansData")
    this.CurrentCaseRegistrationByActorCodeRequest = new CaseRegistrationByActorCodeRequest();

    this.CurrentCaseRegistrationByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCaseRegistrationByActorCodeController();
  }

  GetCaseRegistrationByActorCodeController() {
    this.StartRefreshing();
    this.CurrentCaseRegistrationByActorCodeRequest.ActorCode = this.ActorCode;
    //this.CurrentCaseRegistrationByActorCodeRequest.FromDate = new Date();
    //this.CurrentCaseRegistrationByActorCodeRequest.ToDate = new Date();
    this.CurrentCaseRegistrationByActorCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentCaseRegistrationByActorCodeRequest.ConditionalOperator = 10;
    this.actorservice.GetCaseRegistrationByActorCodeController(this.CurrentCaseRegistrationByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCaseRegistrationByActorCodeController = this.ApiResData.Result;
          this.PatientDetailsData = this.CurrentCaseRegistrationByActorCodeController[0];
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentOverseasController: OverseasController;
  LoadOverseas() {
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101032;
    getReq.Params = [
      new FTV('PatientFormattedCode', 'string', this.FormattedCode)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101032;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result) {
            let rawData: any = this.ApiResData.Result;
            if (Array.isArray(rawData) && rawData.length > 0) {
              if (typeof rawData[0] === 'string') {
                try { this.CurrentOverseasController = JSON.parse(rawData.join(""))[0]; } catch (e) { }
              } else if (rawData[0] && typeof rawData[0].ResultData === 'string') {
                try { this.CurrentOverseasController = JSON.parse(rawData[0].ResultData)[0]; } catch (e) { }
              } else {
                this.CurrentOverseasController = rawData[0];
              }
            }
          }
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  } 
  AddPartner() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 20;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.SelectedPatient.DateOfBirth;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = this.ActorCode;
    this.CurrentSavePatientInfoRequest.AddressLine1 = this.SelectedPatient.AddressLine1;
    this.CurrentSavePatientInfoRequest.Telephone1 = this.SelectedPatient.Telephone1;
    this.CurrentSavePatientInfoRequest.Prefix = this.SelectedPatient.Prefix;
    this.CurrentSavePatientInfoRequest.Gender = this.SelectedPatient.Gender;

    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.SelectedPatient.ReferalDetailCode;
    this.CurrentSavePatientInfoRequest.RefCode = this.SelectedPatient.RefCode;
    this.CurrentSavePatientInfoRequest.RefType = this.SelectedPatient.RefType;
    this.CurrentSavePatientInfoRequest.RefDetails = this.SelectedPatient.RefDetails;
    this.CurrentSavePatientInfoRequest.RefContactNo = this.SelectedPatient.RefContactNo1;
    this.CurrentSavePatientInfoRequest.RefInstitute = this.SelectedPatient.RefInstitute;
    this.CurrentSavePatientInfoRequest.RefContactNo2 = this.SelectedPatient.RefContactNo2;
    this.CurrentSavePatientInfoRequest.Remarks = this.SelectedPatient.Remarks;
    this.CurrentSavePatientInfoRequest.Religion = this.SelectedPatient.Religion;
    this.CurrentSavePatientInfoRequest.Institution = this.SelectedPatient.Institution;
    this.CurrentSavePatientInfoRequest.BloodGroup = this.SelectedPatient.BloodGroup;
    this.CurrentSavePatientInfoRequest.BirthIdentification1 = this.SelectedPatient.BirthIdentification1;
    this.CurrentSavePatientInfoRequest.Occupation = this.SelectedPatient.Occupation;
    this.CurrentSavePatientInfoRequest.Nationality = this.SelectedPatient.Nationality;
    this.CurrentSavePatientInfoRequest.EducationTitle = this.SelectedPatient.EducationTitle;
    this.CurrentSavePatientInfoRequest.EducationInDetail = this.SelectedPatient.EducationInDetail;
    this.CurrentSavePatientInfoRequest.IsInsured = this.SelectedPatient.IsInsured;
    this.CurrentSavePatientInfoRequest.InsuranceProvider = this.SelectedPatient.InsuranceProvider;
    this.CurrentSavePatientInfoRequest.MaritalStatus = this.SelectedPatient.MaritalStatus;
    this.CurrentSavePatientInfoRequest.Language = this.SelectedPatient.LanguagesKnown;
    this.CurrentSavePatientInfoRequest.OldRegistrationNo = this.SelectedPatient.OldRegistrationNumber;
    //this.CurrentSavePatientInfoRequest.Age = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.RegistrationType = this.SelectedPatient.RegistrationType;
    this.CurrentSavePatientInfoRequest.RegistrationReason = this.SelectedPatient.RegistrationReason;
    this.CurrentSavePatientInfoRequest.BillingCategory = this.SelectedPatient.BillingCategory;
    this.CurrentSavePatientInfoRequest.RegistrationValidity = this.SelectedPatient.RegistrationValidity;
    this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.SelectedPatient.PrimaryDoctor;
    this.CurrentSavePatientInfoRequest.City = this.SelectedPatient.City;
    this.CurrentSavePatientInfoRequest.State = this.SelectedPatient.State;
    this.CurrentSavePatientInfoRequest.County = this.SelectedPatient.County;
    this.CurrentSavePatientInfoRequest.ZipCode = this.SelectedPatient.ZipCode;
    this.CurrentSavePatientInfoRequest.Telephone2 = this.SelectedPatient.Telephone2;
    this.CurrentSavePatientInfoRequest.Email = this.SelectedPatient.Email;
    this.CurrentSavePatientInfoRequest.AddressLine2 = this.SelectedPatient.AddressLine2;
    this.CurrentSavePatientInfoRequest.IdProof = this.SelectedPatient.IdProof;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.AddressCode = this.SelectedPatient.AddressCode;
    //this.CurrentSavePatientInfoRequest. = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.DisplayName = this.SelectedPatient.DisplayName;

    if (this.CurrentOverseasController != null) {
      this.CurrentUpdateOverseas.PassportNumber = this.CurrentOverseasController.PassportNumber;
      this.CurrentUpdateOverseas.PassportExpiryDate = this.CurrentOverseasController.PassportExpiryDate;
      this.CurrentUpdateOverseas.IssueCountry = this.CurrentOverseasController.IssueCountry;
      this.CurrentUpdateOverseas.VisaType = this.CurrentOverseasController.VisaType;
      this.CurrentUpdateOverseas.VisaExpiryDate = this.CurrentOverseasController.VisaExpiryDate;
      this.CurrentUpdateOverseas.NationalRegNo = this.CurrentOverseasController.NationalRegNo;
    }


    this.CurrentUpdateBillingCategory.BillingCategory = this.SelectedPatient.BillingCategory;
    if (this.PatientDetailsData != null) {
      this.CurrentUpdateWeddingDate.WeddingDate = this.PatientDetailsData.MarriageDate;
    }
    const modalRef = this.modalService.open(NgbAddPartnerModal,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    modalRef.componentInstance.CurrentSavePatientInfoRequest = this.CurrentSavePatientInfoRequest;
    modalRef.componentInstance.FormattedCode = this.SelectedPatient.FormattedCode;
    modalRef.componentInstance.CurrentUpdateOverseas = this.CurrentUpdateOverseas;
    modalRef.componentInstance.CurrentUpdateBillingCategory = this.CurrentUpdateBillingCategory;
    modalRef.componentInstance.CurrentUpdateWeddingDate = this.CurrentUpdateWeddingDate;
    modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    //modalRef.componentInstance.ActorCode = this.ActorCode;



  }
  EditDetails() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 20;
    this.CurrentSavePatientInfoRequest.ActorType = 3;
    this.CurrentSavePatientInfoRequest.DateOfBirth = this.SelectedPatient.DateOfBirth;
    this.CurrentSavePatientInfoRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSavePatientInfoRequest.ActorCode = this.ActorCode;
    this.CurrentSavePatientInfoRequest.AddressLine1 = this.SelectedPatient.AddressLine1;
    this.CurrentSavePatientInfoRequest.Telephone1 = this.SelectedPatient.Telephone1;
    this.CurrentSavePatientInfoRequest.Prefix = this.SelectedPatient.Prefix;
    this.CurrentSavePatientInfoRequest.Gender = this.SelectedPatient.Gender;

    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.SelectedPatient.ReferalDetailCode;
    this.CurrentSavePatientInfoRequest.RefCode = this.SelectedPatient.RefCode;
    this.CurrentSavePatientInfoRequest.RefType = this.SelectedPatient.RefType;
    this.CurrentSavePatientInfoRequest.RefDetails = this.SelectedPatient.RefDetails;
    this.CurrentSavePatientInfoRequest.RefContactNo = this.SelectedPatient.RefContactNo1;
    this.CurrentSavePatientInfoRequest.RefInstitute = this.SelectedPatient.RefInstitute;
    this.CurrentSavePatientInfoRequest.RefContactNo2 = this.SelectedPatient.RefContactNo2;
    this.CurrentSavePatientInfoRequest.Remarks = this.SelectedPatient.Remarks;
    this.CurrentSavePatientInfoRequest.Religion = this.SelectedPatient.Religion;
    this.CurrentSavePatientInfoRequest.Institution = this.SelectedPatient.Institution;
    this.CurrentSavePatientInfoRequest.BloodGroup = this.SelectedPatient.BloodGroup;
    this.CurrentSavePatientInfoRequest.BirthIdentification1 = this.SelectedPatient.BirthIdentification1;
    this.CurrentSavePatientInfoRequest.Occupation = this.SelectedPatient.Occupation;
    this.CurrentSavePatientInfoRequest.Nationality = this.SelectedPatient.Nationality;
    this.CurrentSavePatientInfoRequest.EducationTitle = this.SelectedPatient.EducationTitle;
    this.CurrentSavePatientInfoRequest.EducationInDetail = this.SelectedPatient.EducationInDetail;
    this.CurrentSavePatientInfoRequest.IsInsured = this.SelectedPatient.IsInsured;
    this.CurrentSavePatientInfoRequest.InsuranceProvider = this.SelectedPatient.InsuranceProvider;
    this.CurrentSavePatientInfoRequest.MaritalStatus = this.SelectedPatient.MaritalStatus;
    this.CurrentSavePatientInfoRequest.Language = this.SelectedPatient.LanguagesKnown;
    this.CurrentSavePatientInfoRequest.OldRegistrationNo = this.SelectedPatient.OldRegistrationNumber;
    //this.CurrentSavePatientInfoRequest.Age = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.RegistrationType = this.SelectedPatient.RegistrationType;
    this.CurrentSavePatientInfoRequest.RegistrationReason = this.SelectedPatient.RegistrationReason;
    this.CurrentSavePatientInfoRequest.BillingCategory = this.SelectedPatient.BillingCategory;
    this.CurrentSavePatientInfoRequest.RegistrationValidity = this.SelectedPatient.RegistrationValidity;
    this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.SelectedPatient.PrimaryDoctor;
    this.CurrentSavePatientInfoRequest.City = this.SelectedPatient.City;
    this.CurrentSavePatientInfoRequest.State = this.SelectedPatient.State;
    this.CurrentSavePatientInfoRequest.County = this.SelectedPatient.County;
    this.CurrentSavePatientInfoRequest.ZipCode = this.SelectedPatient.ZipCode;
    this.CurrentSavePatientInfoRequest.Telephone2 = this.SelectedPatient.Telephone2;
    this.CurrentSavePatientInfoRequest.Email = this.SelectedPatient.Email;
      this.CurrentSavePatientInfoRequest.AddressLine2 = this.SelectedPatient.AddressLine2;
      this.CurrentSavePatientInfoRequest.IdProof = this.SelectedPatient.IdProof;
    this.CurrentSavePatientInfoRequest.CreatedUser = AppData.Instance().UserLoginDetails.EmployeeCode;
    this.CurrentSavePatientInfoRequest.AddressCode = this.SelectedPatient.AddressCode;
    //this.CurrentSavePatientInfoRequest. = this.SelectedPatient.Age;
    this.CurrentSavePatientInfoRequest.UserLoginFacility = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    this.CurrentSavePatientInfoRequest.DisplayName = this.SelectedPatient.DisplayName;

    if (this.CurrentOverseasController != null) {
      this.CurrentUpdateOverseas.PassportNumber = this.CurrentOverseasController.PassportNumber;
      this.CurrentUpdateOverseas.PassportExpiryDate = this.CurrentOverseasController.PassportExpiryDate;
      this.CurrentUpdateOverseas.IssueCountry = this.CurrentOverseasController.IssueCountry;
      this.CurrentUpdateOverseas.VisaType = this.CurrentOverseasController.VisaType;
      this.CurrentUpdateOverseas.VisaExpiryDate = this.CurrentOverseasController.VisaExpiryDate;
      this.CurrentUpdateOverseas.NationalRegNo = this.CurrentOverseasController.NationalRegNo;
    }


    this.CurrentUpdateBillingCategory.BillingCategory = this.SelectedPatient.BillingCategory;
    if (this.PatientDetailsData != null) {
      this.CurrentUpdateWeddingDate.WeddingDate = this.PatientDetailsData.MarriageDate;  
    }    
    const modalRef = this.modalService.open(NgbEditProfileModal,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    modalRef.componentInstance.CurrentSavePatientInfoRequest = this.CurrentSavePatientInfoRequest;
    modalRef.componentInstance.FormattedCode = this.SelectedPatient.FormattedCode;
    modalRef.componentInstance.CurrentUpdateOverseas = this.CurrentUpdateOverseas;
    modalRef.componentInstance.CurrentUpdateBillingCategory = this.CurrentUpdateBillingCategory;
    modalRef.componentInstance.CurrentUpdateWeddingDate = this.CurrentUpdateWeddingDate;
    modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    //modalRef.componentInstance.ActorCode = this.ActorCode;



  }
  //ngAfterViewInit() {
  //  //pSteps.loadStep();
  //}
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData.Result[0];

          this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
          this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
          this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
          this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
          this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
          this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
          this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;



          if (this.CurrentActorPersonalDetailInfoController.DateOfBirth != null) {

            var SDOB = new Date(this.CurrentActorPersonalDetailInfoController.DateOfBirth);
            ;
            if (SDOB.getFullYear() > 1900) {

              this.DOB = {

                year: SDOB.getFullYear(),
                month: SDOB.getMonth() + 1,
                day: SDOB.getDate()
              }
            }
            else {
              this.DOB = {

                year: 1900,
                month: 1,
                day: 1
              }
            }
          }
          this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
          this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
          this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
          this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
          this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
          this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
          this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
          this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
          this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
          //
          //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
          this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
          this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
          this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA"
          //this.CurrentActorPersonalDetailInfoController.Country;
          this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
          this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
          this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
          this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
          this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;
          this.CurrentActorPersonalDetailInfoRequest.Zip = this.CurrentActorPersonalDetailInfoController.Zip;
          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          //this.key = this.ApiResData.Result[0];

          //this.personalInfoChange.emit(this.key);
          // console.log('this.personalInfoChange' + this.key.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
      this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
      this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
      this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
      this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
      this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
      this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
      this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
      this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
      this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
      this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
      this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
      this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
      this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
      //
      //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
      this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
      this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
      this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA";
      //this.CurrentActorPersonalDetailInfoController.Country;
      this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
      this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
      this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
      this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
      this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;

      //
      this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
      this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }
  Partner() {

    const modalRef = this.modalService.open(NgbPartnerDetails,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
  }
  ChangeImage() {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.componentInstance.Photo = this.SelectedPatient.Photo;
  }

  //printcaserecord() {
  //  this.router.navigate(['print/caserecord']);
  //}
  printcaserecord() {
    this.printService.printDocument2(this.SelectedPatient.FormattedCode, 0

    );
    this.printService.printDocument("caserecord",
      {
        ActorCodeData: this.SelectedPatient.ActorCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
  //printcaserecordind() {
  //  this.router.navigate(['print/caserecordindividual', { FormattedCodeData: this.SelectedPatient.FormattedCode }]);
  //}
  printcaserecordind() {
    this.printService.printDocument2(this.SelectedPatient.FormattedCode, 0

    );
    this.printService.printDocument("caserecordindividual",
      {
        FormattedCodeData: this.SelectedPatient.FormattedCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
  printidl() {
    this.printService.printDocument("IDL",
      {
        FormattedCodeData: this.SelectedPatient.FormattedCode, FaclityCodeData: this.SelectedPatient.FacilityCode,
      }
    );
  }
}
